import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import TTPaymentLogLoad from './TTPaymentLogLoad';

const TTPaymentLog = (props) => {
    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <TTPaymentLogLoad className='mt-3' themeSelected={themeSelected} />
        </div>
    );
};

export default TTPaymentLog;